const QuickRight = () => {
  return (
    <div className="fixed right-5 bottom-10 z-40">
      <div className="grid grid-rows-2 gap-3">
        <button
          type="button"
          className="hover:-translate-y-2 hover:shadow-lg rounded-full transition-transform duration-300"
          onClick={() =>
            window.open("https://smartstore.naver.com/sarahscoffee")
          }
        >
          <img
            src="/images/iconNaver.png"
            alt="shopping"
            className="rounded-full !relative w-20 h-auto"
          />
        </button>
        <button
          type="button"
          className="hover:-translate-y-2 hover:shadow-lg rounded-full transition-transform duration-300"
          onClick={() =>
            window.open(
              "https://www.instagram.com/gb_sarahscoffee?igsh=MXE0ODkwYXJ5cnYyOA==",
            )
          }
        >
          <img
            src="/images/iconInsta.png"
            alt="shopping"
            className="rounded-full !relative w-20 h-auto"
          />
        </button>
      </div>
    </div>
  );
};

export default QuickRight;
